import {
  Alert,
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
  Typography,
} from "@mui/material";
import { sizeLimit } from "config/maxLayerSize";
import { projections } from "config/projections";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GeopuntLocation, SubLayer } from "types/types";
import { getShapefileUrl, getWcsUrl } from "utils/GeoserverUtils";
import { LayerSetDialogSearch } from "../LayerSetDialogSearch";

interface Props {
  subLayerList: SubLayer[];
}

export default function GroupLayerDownload(props: Props) {
  const { subLayerList } = props;
  const { t } = useTranslation();

  const [firstSubLayer] = subLayerList;

  const availableProjections = projections;

  const [firstProjection] = availableProjections;

  const [location, setLocation] = useState<GeopuntLocation>();

  const [projectionUrl, setProjectionUrl] = useState(firstProjection.url);

  const [selectedSubLayer, setSelectedSubLayer] =
    useState<SubLayer>(firstSubLayer);

  const isTooBig = !!subLayerList.find((layer) => layer.size_MB > sizeLimit);

  function onSelectLocation(location: GeopuntLocation) {
    setLocation(location);
  }

  function onChange(e: SelectChangeEvent<string>) {
    setProjectionUrl(e.target.value);
  }

  function onStartDownload() {
    if (selectedSubLayer.type === "WMS") {
      const url = getWcsUrl(
        selectedSubLayer.geoserverLayer,
        projectionUrl,
        location
      );
      return window.open(url, `${selectedSubLayer.geoserverLayer}`);
    }
    const url = getShapefileUrl(
      selectedSubLayer.geoserverLayer,
      projectionUrl,
      location
    );
    return window.open(url, `${selectedSubLayer.geoserverLayer}`);
  }

  function onChangeLayer(e: SelectChangeEvent<number>, value: any) {
    const selectedLayer = subLayerList.find(
      (subLayer) => subLayer.id === e.target.value
    );

    setSelectedSubLayer(selectedLayer || firstSubLayer);
  }

  return (
    <StyledBox>
      <Alert severity="info">{t("label.warningLayerGroup")}</Alert>
      {isTooBig && <Alert severity="warning">{t("label.layerTooBig")}</Alert>}
      {isTooBig && <LayerSetDialogSearch onSelectLocation={onSelectLocation} />}

      <FormControl fullWidth>
        <Typography>Laag</Typography>
        <Select value={selectedSubLayer.id} onChange={onChangeLayer}>
          {subLayerList.map((subLayer) => (
            <MenuItem value={subLayer.id}>{subLayer.geoserverLayer}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <Typography>Projectiesysteem</Typography>
        <Select value={projectionUrl} onChange={onChange}>
          {availableProjections.map((proj) => (
            <MenuItem key={proj.id} value={proj.url}>
              {proj.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        disabled={isTooBig && !location}
        onClick={() => onStartDownload()}
      >
        {selectedSubLayer.type === "WMS" && t("label.download")}
        {selectedSubLayer.type === "WFS" && t("label.downloadShapefile")}
      </Button>
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  .MuiInputBase-input {
    padding-top: ${({ theme }) => theme.spacing(1)};
    padding-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;
